import { KpiDashboardData } from "../../pages/Dashboard/ChatJess/components/KpiPanel/types";
import { URLS } from "../../constants";
import { getLoggedinUser } from "../../api/apiCore";
import { GET_AGENT_KPI_DASHBOARD } from "../../api/urls";

const getBaseUrl = (): string => {
  return URLS.AGENT_PROXY_URL || "https://dev-agent-proxy.jesss.ai";
};

const getCompanyId = (): string | null => {
  const user = getLoggedinUser();
  return user?.companyID || null;
};

export const fetchKpiDashboard = async (): Promise<KpiDashboardData> => {
  const baseUrl = getBaseUrl();
  const companyId = getCompanyId();

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (companyId) {
    headers["X-Company-ID"] = companyId;
  }

  const response = await fetch(`${baseUrl}${GET_AGENT_KPI_DASHBOARD}`, {
    method: "GET",
    headers,
    credentials: "include",
  });

  if (response.status === 404) {
    // No cached data yet — not an error, data will arrive via WebSocket
    return null as unknown as KpiDashboardData;
  }

  if (!response.ok) {
    throw new Error(`Failed to fetch KPI dashboard: ${response.status}`);
  }

  return response.json();
};
